
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
    apiKey: "AIzaSyAd6aE91SDQKG7hz6jD03yHxWQyxQ53pvk",
    authDomain: "lovodi-e9ba7.firebaseapp.com",
    projectId: "lovodi-e9ba7",
    storageBucket: "lovodi-e9ba7.appspot.com",
    messagingSenderId: "382730596301",
    appId: "1:382730596301:web:28ad6412e2be4589d0de84"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);